import React from 'react';
import { ZoomClient } from '../zoom.config';
export default React.createContext<ZoomClient>(null as any);
